import React from 'react';
import { Grid, GridItem } from '@ktag/styleguide/dist/react';
import { JobPortalScreen, JobResult } from 'jobs.types';
import AboTeaser from 'components/aboteaser/AboTeaser';
import useLocalStorage from 'javascripts/useLocalStorage';
import JobTeaser, { VisitedJob } from '../jobteaser/JobTeaser';
import useCleanUpVisitedJobs from './useCleanUpVisitedJobs';

const PlaceholderEntry = () => (
  <div className="jobportal__placeholder">
    <div className="jobportal__placeholderheadline" />
    <div className="jobportal__placeholderline" />
    <div className="jobportal__placeholderline" />
  </div>
);

const ENTRIES_BEFORE_TEASER = 5;

interface Props {
  newThresholdHours: string;
  jobs: JobResult[];
  loading: boolean;
  setScreen?: (screen: JobPortalScreen) => void;
  listOnly?: boolean;
}

const JobList = ({ newThresholdHours, jobs, loading, setScreen, listOnly }: Props) => {
  const [visitedJobs, setVisitedJobs] = useLocalStorage<VisitedJob[]>('visitedJobs', []);

  // every time, the app renders, we make sure, we don't carry over old job ids in local storage
  useCleanUpVisitedJobs(newThresholdHours, visitedJobs, setVisitedJobs);

  const renderLoadingPlaceholders = () => {
    return [...Array(5)].map((x, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <GridItem additionalClassNames="joblist__entry" key={i}>
        <PlaceholderEntry />
      </GridItem>
    ));
  };

  if (loading) {
    return renderLoadingPlaceholders();
  }

  const newThresholdMs = parseInt(newThresholdHours, 10) * 60 * 60 * 1000;

  const gridItems = jobs?.map((job) => {
    return (
      <GridItem additionalClassNames="joblist__entry" key={job.id}>
        <JobTeaser
          job={job}
          newThresholdMs={newThresholdMs}
          visitedJobs={visitedJobs}
          setVisitedJobs={setVisitedJobs}
        />
      </GridItem>
    );
  });

  if (!listOnly) {
    if (jobs && jobs.length >= ENTRIES_BEFORE_TEASER) {
      gridItems.splice(
        ENTRIES_BEFORE_TEASER,
        0,
        <GridItem key="abo-teaser">
          <AboTeaser setScreen={setScreen} />
        </GridItem>,
      );
    } else {
      gridItems.push(
        <GridItem key="abo-teaser">
          <AboTeaser setScreen={setScreen} />
        </GridItem>,
      );
    }
  }

  return (
    <Grid additionalClassNames="joblist" animated>
      {gridItems}
    </Grid>
  );
};

export default JobList;
